module.exports = __webpack_public_path__ + "img/xiaoniao.d97e1f67.png";